import primaryButton from '../../../../primary-button';

const secondary = (params) => primaryButton.solidIcon.background.default.secondary(params);

export default secondary;
